import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BreadcrumbComponent } from '@app/lib/components/breadcrumb/breadcrumb.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BaseHttpService } from '@app/lib/services/base-http.service';
import { AppConfiguration } from '@app/lib/services/app-config.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DialogService } from '@app/lib/services/dialog.service';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { ResetPasswordScreenService } from '../services/reset-password-screen.service';
import { IResponse } from '@app/lib/models/response.model';
import { ResetPassword } from '../models/reset-password.model';
import { MatSort, MatSortModule } from '@angular/material/sort';

@Component({
    selector: 'app-reset-password',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        HttpClientModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatCheckboxModule,
        BreadcrumbComponent,
        MatProgressBarModule,
        MatDialogModule,
        MatSortModule
    ],
    templateUrl: './reset-password-screen.component.html',
    styleUrl: './reset-password-screen.component.scss'
})
export class ResetPasswordComponentScreen implements OnInit, AfterViewInit {
    pageTitle = 'Reset Password';
    breadcrumbs = [
        { label: 'Admin' },
        { label: 'Reset Password' }
    ];
    
    searchForm!: FormGroup;
    dataSource = new MatTableDataSource<any>();
    displayedColumns: string[] = ['select', 'partyId', 'userName', 'emailAddress'];
    
    selectedRows: any[] = [];
    isLoading = false;
    hasSearched = false;
    @ViewChild(MatSort) sort!: MatSort;

    constructor(
        private fb: FormBuilder,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private service:ResetPasswordScreenService
    ) {
        
    }

    ngOnInit(): void {
        this.initSearchForm();
    }
    ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        }

    private showDialog(title: string, message: string): void {
        this.dialogService.openDialog1({
            data: {
                title: title,
                message: message,
                icon: title.toLowerCase().includes('error') ? 'error' : 'check_small'
            },
            disableClose: true,
            hasBackdrop: true,
            backdropClass: 'dialog-backdrop',
        });
    }

    initSearchForm(): void {
        this.searchForm = this.fb.group({
            userName: ['', [Validators.required, this.noSpecialCharsValidator]]
        });
        }

    private noSpecialCharsValidator(control: any) {
        if (!control.value) {
            return null;
        }
        const hasSpecialChars = /[^a-zA-Z0-9 ]/.test(control.value);
        return hasSpecialChars ? { 'specialChars': true } : null;
    }
     handleSearch() {
        if (this.searchForm.invalid) return;

        const queryParams: any = {
          userName:this.searchForm.value.userName
        }
      
        this.service.getUserForReset(queryParams)
          .subscribe({
            next: (res: IResponse<ResetPassword[]>) => {
             this.dataSource.data = res?.success || res?.data || res || [];
             this.dataSource.sort = this.sort;
                this.isLoading = false;
                this.hasSearched = true;
                this.selectedRows = [];

                if (this.dataSource.data.length === 0) {
                    this.showDialog('Information', 'No records found.');
                }},
                error: (err: any) => {
                console.error('Search Failed', err);
                this.isLoading = false;
            }
          });
      }


    handleFormReset(): void {
        this.searchForm.reset();
        this.dataSource.data = [];
        this.selectedRows = [];
        this.hasSearched = false;
    }

    toggleSelection(row: any, checked: boolean): void {
        if (checked) {
            this.selectedRows = [row]; // Assuming single selection for reset password
        } else {
            this.selectedRows = [];
        }
    }

    isSelected(row: any): boolean {
        return this.selectedRows.includes(row);
    }

    handleResetPassword(): void {
        if (this.selectedRows.length === 0) return;

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: {
                title: 'Confirm Action',
                message: `Are you sure you want to reset the password for ${this.selectedRows[0].userName || 'the selected user'}?`,
            },
            disableClose: true,
            hasBackdrop: true,
            backdropClass: 'dialog-backdrop',
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.executeResetPassword();
            }
        });
    }


    private executeResetPassword(): void {
        this.isLoading = true;

        const reqBody = this.selectedRows.map(row => ({
           "userId": row.userId,
            "contactsSequence": row.contactsSequence,
            "transType": "",
            "emailAddress": row.emailAddress,
            "partyId": row.partyId,
            "userName": row.userName
        }));

       this.service.resetPassword(reqBody)
          .subscribe({
            next: (res: IResponse<any>) => {
                 this.isLoading = false;
                this.selectedRows = [];
                this.handleSearch(); 
                
                if (res?.data) {
                    this.showDialog('Success', res.data);
                } else {
                    this.showDialog('Error', res.data);
                }
            },
                error: (err: any) => {
                console.error('Search Failed', err);
                this.isLoading = false;
            
    } });
}
}
